export function getPaperPublishManagementColumns(handlers) {
  return getColumns(handlers, paperPublishManagementColumns);
}

export function getReviewerResultColumns(handlers) {
  return getColumns(handlers, reviewerResultColumns);
}

export function getFinalReviewStatusColumns(handlers) {
  return getColumns(handlers, finalReviewStatusColumns);
}


function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const finalReviewStatusColumns = [
  {
    text: "상태",
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: "차수",
    value: "level",
    type: "text",
  },
  {
    text: "제목",
    value: "title",
    type: "text",
  },
  {
    text: "Actions",
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "description",
        color: "black",
        key: "description",
        handler: null,
      },
    ],
  },
];

const reviewerResultColumns = [ 
  {
    text: "심사위원",
    value: "reviewer_name",
    type: "text",
    highlighted: true,
  },
  {
    text: "상태",
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: "차수",
    value: "level",
    type: "text",
  },
  {
    text: "심사 마감일",
    value: "review_deadline",
    type: "text",
  },
  {
    text: "결과",
    value: "result",
    type: "text",
  },
  {
    text: "의견",
    type: "button",
    actions: [
      {
        icon: "description",
        buttonClass: "md-primary md-simple",
        key: "description",
        handler: null,
      },
    ],
  },
];

